import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommercePropertyProps, IGetGtmEcommercePropertyPropsShort} from "../common/get_gtm_ecommerce_property_props";

interface IListParams {
    page: number;
    pageSize: number;
}

export interface IHitGTMPropertyViewItemListParams {
    offer: IGtmEcommerceOfferItemBaseProps;
    properties: IGetGtmEcommercePropertyPropsShort[];
    listId: string;
    listName: string;
    listParams?: IListParams;
}

export interface IHitGTMPropertyViewItemListParamsDifferentOffers {
    properties: (IGetGtmEcommercePropertyPropsShort & {offer: IGtmEcommerceOfferItemBaseProps})[];
    listId: string;
    listName: string;
    listParams?: IListParams;
}

export const hitGTMPropertyViewItemList = (params: IHitGTMPropertyViewItemListParams | IHitGTMPropertyViewItemListParamsDifferentOffers) => {
    const page = params.listParams?.page || 1;
    const pageSize = params.listParams?.pageSize || 10;
    const indexNormalization = (page - 1) * pageSize;

    const items: IGTMEcommerceItem[] = params.properties.map((property, index) => {
        return {
            ...getGtmEcommerceOfferItemBaseProps(hasOfferProp(params) ? params.offer : (property as {offer: IGtmEcommerceOfferItemBaseProps}).offer),
            item_category: "property",
            ...getGTMEcommercePropertyProps({
                property,
                short: true
            }),
            index: index + 1 + (indexNormalization || 0)
        };
    });

    hitGoogleTagManager({
        event: "view_item_list",
        ecommerce: {
            item_list_id: params.listId,
            item_list_name: params.listName,
            items
        }
    });
};

const hasOfferProp = (
    params: IHitGTMPropertyViewItemListParams | IHitGTMPropertyViewItemListParamsDifferentOffers
): params is IHitGTMPropertyViewItemListParams => {
    return Boolean("offer" in params && params.offer);
};
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommercePropertyProps, IGetGtmEcommercePropertyPropsShort} from "../common/get_gtm_ecommerce_property_props";

interface IListParams {
    page: number;
    pageSize: number;
}

export interface IHitGTMPropertyViewItemListParams {
    offer: IGtmEcommerceOfferItemBaseProps;
    properties: IGetGtmEcommercePropertyPropsShort[];
    listId: string;
    listName: string;
    listParams?: IListParams;
}

export interface IHitGTMPropertyViewItemListParamsDifferentOffers {
    properties: (IGetGtmEcommercePropertyPropsShort & {offer: IGtmEcommerceOfferItemBaseProps})[];
    listId: string;
    listName: string;
    listParams?: IListParams;
}

export const hitGTMPropertyViewItemList = (params: IHitGTMPropertyViewItemListParams | IHitGTMPropertyViewItemListParamsDifferentOffers) => {
    const page = params.listParams?.page || 1;
    const pageSize = params.listParams?.pageSize || 10;
    const indexNormalization = (page - 1) * pageSize;

    const items: IGTMEcommerceItem[] = params.properties.map((property, index) => {
        return {
            ...getGtmEcommerceOfferItemBaseProps(hasOfferProp(params) ? params.offer : (property as {offer: IGtmEcommerceOfferItemBaseProps}).offer),
            item_category: "property",
            ...getGTMEcommercePropertyProps({
                property,
                short: true
            }),
            index: index + 1 + (indexNormalization || 0)
        };
    });

    hitGoogleTagManager({
        event: "view_item_list",
        ecommerce: {
            item_list_id: params.listId,
            item_list_name: params.listName,
            items
        }
    });
};

const hasOfferProp = (
    params: IHitGTMPropertyViewItemListParams | IHitGTMPropertyViewItemListParamsDifferentOffers
): params is IHitGTMPropertyViewItemListParams => {
    return Boolean("offer" in params && params.offer);
};
